import type { Section } from 'src/core/contexts/PatientContactContext'

export const isSectionsNote = (note: unknown): note is Section[] => {
	return Array.isArray(note) && note.every((item) => typeof item === 'object' && item !== null && 'id' in item)
}
